export default __webpack_public_path__ + "static/media/crossfire.bef5a9ab.png";